<template>
  <div>
    <div class="text-center" v-if="pages > 1">
      <v-pagination v-model="page" :length="pages"></v-pagination>
    </div>
    <div
      class="d-flex flex-row mb-6 align-self-center d-flex justify-center flex-wrap pa-2"
    >
      <v-btn
        :loading="saving"
        :disabled="!selectedImage"
        color="error"
        @click="deleteHandler(selectedImage)"
        >{{ $t("globals.delete") }}</v-btn
      >
    </div>
    <div class="d-flex flex-row mb-6 align-self-center flex-wrap">
      <div v-for="icon of images" v-bind:key="icon.Id">
        <div
          tabindex="0"
          :class="[
            selectedImage && selectedImage.Id == icon.Id ? 'primary' : '',
            'icon',
          ]"
          @focus="$emit('update:selectedImage', icon)"
        >
          <div
            class="icon-wrapper"
            :style="{
              'background-image': 'url(' + icon.PhysicalFile.Path + ')',
            }"
          ></div>
        </div>
      </div>
    </div>
    <div class="no-items" v-if="images.length == 0">{{ $t("globals.no_items") }}</div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  props: {
    selectedImage: Object,
  },
  data: () => ({
    saving:false,
    images: [],
    pages: 0,
    page: 1,
  }),
  computed: {
    ...mapGetters("common", { selectedPlan: "plan", settings: "settings" }),
  },
  watch: {
    page: {
      immediate: true,
      handler() {
        this.loadImages();
      },
    },
    // selectedImage: {
    //   immediate: true,
    //   handler(img) {
    //     //console.log(img)
    //   },
    // }
  },
  mounted() {},
  methods: {
    ...mapActions("downloadCenter", ["getImages", "deleteImage"]),
    async loadImages() {
      this.images = (await this.getImages(this.selectedPlan.Id)).value;
    },

    async deleteHandler(item) {
      this.saving = true;
      await this.deleteImage(item);
      this.$emit("update:selectedImage", undefined);
      await this.loadImages();
      this.saving = false;
    },
  },
};
</script>
<style scoped>
.icon {
  margin: 1px;
  border: 6px solid white;
}
.icon-wrapper {
  background: #f9f9f9;
  padding: 3px;
  width: 140px;
  height: 120px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
}
.no-items {
  text-align: center;
  padding: 20px;
}
</style>
